import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

export default function KPIReelTypeTurnRateListItem(props){
    return (
        <TableRow>
            <TableCell>{props.data.reelType}</TableCell>
            <TableCell align="right" sx={{width:"75px"}}>{props.data.days}</TableCell>
        </TableRow>
    )
}

